import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMIB.module.css"
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";
import Input from "../../../../../../../components/textbox/Input";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import $ from 'jquery';
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json"

class DatiAnagraficiMIB extends React.Component {

    state = {
        datiAnagrafici: {
            cognome: this.props.statePadre && this.props.statePadre.cognome ? this.props.statePadre.cognome : "",
            nome: this.props.statePadre && this.props.statePadre.nome ? this.props.statePadre.nome : "",
            dataNascita: this.props.statePadre && this.props.statePadre.dataNascita ? this.props.statePadre.dataNascita : "",
            sesso: this.props.statePadre && this.props.statePadre.sesso ? this.props.statePadre.sesso : "",
            comune: this.props.statePadre && this.props.statePadre.comune ? this.props.statePadre.comune : "",
            stp: this.props.statePadre && this.props.statePadre.stp ? this.props.statePadre.stp : "",
            nazione: this.props.statePadre && this.props.statePadre.nazione ? this.props.statePadre.nazione : "",
            dataInizio: this.props.statePadre && this.props.statePadre.dataInizio ? this.props.statePadre.dataInizio : "",
            comuneInizio: this.props.statePadre && this.props.statePadre.comuneInizio ? this.props.statePadre.comuneInizio : "",
            provincia: this.props.statePadre && this.props.statePadre.provincia ? this.props.statePadre.provincia : "",
            quadroClinico: {
                checkbox1: this.props.statePadre && this.props.statePadre.quadroClinico && (this.props.statePadre.quadroClinico.checkbox1 || this.props.statePadre.quadroClinico.checkbox1 == false) ? this.props.statePadre.quadroClinico.checkbox1 : this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB.quadroClinico["checkbox1"] ? true : false,
                checkbox2: this.props.statePadre && this.props.statePadre.quadroClinico && (this.props.statePadre.quadroClinico.checkbox2 || this.props.statePadre.quadroClinico.checkbox2 == false) ? this.props.statePadre.quadroClinico.checkbox2 : this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB.quadroClinico["checkbox2"] ? true : false,
                checkbox3: this.props.statePadre && this.props.statePadre.quadroClinico && (this.props.statePadre.quadroClinico.checkbox3 || this.props.statePadre.quadroClinico.checkbox3 == false) ? this.props.statePadre.quadroClinico.checkbox3 : this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB.quadroClinico["checkbox3"] ? true : false,
                checkbox4: this.props.statePadre && this.props.statePadre.quadroClinico && (this.props.statePadre.quadroClinico.checkbox4 || this.props.statePadre.quadroClinico.checkbox4 == false) ? this.props.statePadre.quadroClinico.checkbox4 : this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB.quadroClinico["checkbox4"] ? true : false,
                checkbox5: this.props.statePadre && this.props.statePadre.quadroClinico && (this.props.statePadre.quadroClinico.checkbox5 || this.props.statePadre.quadroClinico.checkbox5 == false) ? this.props.statePadre.quadroClinico.checkbox5 : this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB.quadroClinico["checkbox5"] ? true : false,
                checkbox6: this.props.statePadre && this.props.statePadre.quadroClinico && (this.props.statePadre.quadroClinico.checkbox6 || this.props.statePadre.quadroClinico.checkbox6 == false) ? this.props.statePadre.quadroClinico.checkbox6 : this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB.quadroClinico["checkbox6"] ? true : false,
                checkbox7: this.props.statePadre && this.props.statePadre.quadroClinico && (this.props.statePadre.quadroClinico.checkbox7 || this.props.statePadre.quadroClinico.checkbox7 == false) ? this.props.statePadre.quadroClinico.checkbox7 : this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB.quadroClinico["checkbox7"] ? true : false,
                checkbox8: this.props.statePadre && this.props.statePadre.quadroClinico && (this.props.statePadre.quadroClinico.checkbox8 || this.props.statePadre.quadroClinico.checkbox8 == false) ? this.props.statePadre.quadroClinico.checkbox8 : this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB.quadroClinico["checkbox8"] ? true : false,
                checkbox9: this.props.statePadre && this.props.statePadre.quadroClinico && (this.props.statePadre.quadroClinico.checkbox9 || this.props.statePadre.quadroClinico.checkbox9 == false) ? this.props.statePadre.quadroClinico.checkbox9 : this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB.quadroClinico["checkbox9"] ? true : false,
                altroSpecificare: this.props.statePadre && this.props.statePadre.quadroClinico && (this.props.statePadre.quadroClinico.altroSpecificare || this.props.statePadre.quadroClinico.altroSpecificare == "") ? this.props.statePadre.quadroClinico.altroSpecificare : this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB.quadroClinico["altroSpecificare"] ? this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB.quadroClinico["altroSpecificare"] : "",
            },
            ricoverato: this.props.statePadre && this.props.statePadre.ricoverato ? this.props.statePadre.ricoverato : "",
            dataRicovero: this.props.statePadre && this.props.statePadre.dataRicovero ? this.props.statePadre.dataRicovero : "",
            paziente: this.props.statePadre && this.props.statePadre.paziente ? this.props.statePadre.paziente : "",
            corretto: []
        },
        listaComuni: Utils.distinctComuni(JSON.parse(sessionStorage.getItem("comuni")), new Date()),
        listaProvince: JSON.parse(sessionStorage.getItem("province")),
        listaNazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
        provincePerCodice: JSON.parse(sessionStorage.getItem("provincePerCodice")),

    }

    constructor(props) {
        super(props)

        this.riceviValore = this.riceviValore.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        // this.riceviValoreCheckbox = this.riceviValoreCheckbox.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.disabledDate = this.disabledDate.bind(this)
        this.validate = this.validate.bind(this)

    }

    componentDidMount() {

        let datiAnagrafici = this.state.datiAnagrafici

        if (Utils.isEmpty(this.props.statePadre)) {
            if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB) {

                let datiAnagraficiProps = this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMIB

                datiAnagrafici.cognome = this.props.statePadre && this.props.statePadre.cognome ? this.props.statePadre.cognome : datiAnagraficiProps.cognome ? datiAnagraficiProps.cognome : this.state.datiAnagrafici.cognome
                datiAnagrafici.nome = this.props.statePadre && this.props.statePadre.nome ? this.props.statePadre.nome : datiAnagraficiProps.nome ? datiAnagraficiProps.nome : this.state.datiAnagrafici.nome
                datiAnagrafici.dataNascita = this.props.statePadre && this.props.statePadre.dataNascita ? this.props.statePadre.dataNascita : datiAnagraficiProps.dataNascita ? datiAnagraficiProps.dataNascita : this.state.datiAnagrafici.dataNascita
                datiAnagrafici.sesso = this.props.statePadre && this.props.statePadre.sesso ? this.props.statePadre.sesso : datiAnagraficiProps.sesso ? datiAnagraficiProps.sesso : this.state.datiAnagrafici.sesso
                datiAnagrafici.comune = this.props.statePadre && this.props.statePadre.comune ? this.props.statePadre.comune : datiAnagraficiProps.comune ? this.state.comuniPerCodice[datiAnagraficiProps.comune] ? this.state.comuniPerCodice[datiAnagraficiProps.comune] : this.state.nazioniPerCodice[datiAnagraficiProps.comune] ? this.state.nazioniPerCodice[datiAnagraficiProps.comune] : this.state.datiAnagrafici.comune : this.state.datiAnagrafici.comune

                datiAnagrafici.stp = this.props.statePadre && this.props.statePadre.stp ? this.props.statePadre.stp : datiAnagraficiProps.stp ? datiAnagraficiProps.stp : this.state.datiAnagrafici.stp
                datiAnagrafici.nazione = this.props.statePadre && this.props.statePadre.nazione ? this.props.statePadre.nazione : datiAnagraficiProps.nazione ? this.state.nazioniPerCodice[datiAnagraficiProps.nazione] : this.state.datiAnagrafici.nazione

                datiAnagrafici.dataInizio = this.props.statePadre && this.props.statePadre.dataInizio ? this.props.statePadre.dataInizio : datiAnagraficiProps.dataInizio ? datiAnagraficiProps.dataInizio : this.state.datiAnagrafici.dataInizio
                datiAnagrafici.comuneInizio = this.props.statePadre && this.props.statePadre.comuneInizio ? this.props.statePadre.comuneInizio : datiAnagraficiProps.comuneInizio ? this.state.comuniPerCodice[datiAnagraficiProps.comuneInizio] : this.state.datiAnagrafici.comuneInizio
                datiAnagrafici.provincia = this.props.statePadre && this.props.statePadre.provincia ? this.props.statePadre.provincia : datiAnagraficiProps.provincia ? this.state.provincePerCodice[datiAnagraficiProps.provincia] : this.state.datiAnagrafici.provincia
                datiAnagrafici.ricoverato = this.props.statePadre && this.props.statePadre.ricoverato ? this.props.statePadre.ricoverato : datiAnagraficiProps.ricoverato ? datiAnagraficiProps.ricoverato : this.state.datiAnagrafici.ricoverato
                datiAnagrafici.dataRicovero = this.props.statePadre && this.props.statePadre.dataRicovero ? this.props.statePadre.dataRicovero : datiAnagraficiProps.dataRicovero ? datiAnagraficiProps.dataRicovero : this.state.datiAnagrafici.dataRicovero
                datiAnagrafici.paziente = this.props.statePadre && this.props.statePadre.paziente ? this.props.statePadre.paziente : datiAnagraficiProps.paziente ? datiAnagraficiProps.paziente : this.state.datiAnagrafici.paziente
                datiAnagrafici.quadroClinico.altroSpecificare = this.props.statePadre && this.props.statePadre.quadroClinico && this.props.statePadre.quadroClinico.altroSpecificare ? datiAnagraficiProps.quadroClinico.altroSpecificare : this.state.datiAnagrafici.quadroClinico.altroSpecificare


                if (Utils.isEmpty(this.props.statePadre)) {
                    for (let i = 1; i < 10; i++) {
                        datiAnagrafici.quadroClinico["checkbox" + i] = datiAnagraficiProps.quadroClinico["checkbox" + i] ? datiAnagraficiProps.quadroClinico["checkbox" + i] : this.state.datiAnagrafici.quadroClinico["checkbox" + i]
                    }
                } else {
                    for (let i = 1; i < 10; i++) {
                        datiAnagrafici.quadroClinico["checkbox" + i] = this.props.statePadre && this.props.statePadre.quadroClinico && this.props.statePadre.quadroClinico["checkbox" + i] === true ? true : false
                    }
                }


            } else if (this.props.datiPaziente) {
                let datiPazienteProps = this.props.datiPaziente
                let datiAnagraficiProps = this.props.segnalazioneCopia.datiSanitari

                datiAnagrafici.nome = this.props.statePadre && this.props.statePadre.nome ? this.props.statePadre.nome : datiPazienteProps.nomePaziente
                datiAnagrafici.cognome = this.props.statePadre && this.props.statePadre.cognome ? this.props.statePadre.cognome : datiPazienteProps.cognomePaziente
                datiAnagrafici.dataNascita = this.props.statePadre && this.props.statePadre.dataNascita ? this.props.statePadre.dataNascita : datiPazienteProps.dataDiNascita
                datiAnagrafici.sesso = this.props.statePadre && this.props.statePadre.sesso ? this.props.statePadre.sesso : datiPazienteProps.sesso ? datiPazienteProps.sesso === "M" ? "sesso1" : "sesso2" : ""
                datiAnagrafici.comune = this.props.statePadre && this.props.statePadre.comune ? this.props.statePadre.comune : datiPazienteProps.comuneResidenza && datiPazienteProps.comuneResidenza.codice ? this.state.comuniPerCodice[datiPazienteProps.comuneResidenza.codice] ? this.state.comuniPerCodice[datiPazienteProps.comuneResidenza.codice] : this.state.nazioniPerCodice[datiPazienteProps.comuneResidenza.codice] ? this.state.nazioniPerCodice[datiPazienteProps.comuneResidenza.codice] : "" : ""
                datiAnagrafici.stp = this.props.statePadre && this.props.statePadre.stp ? this.props.statePadre.stp : datiPazienteProps.codiceFiscale ? datiPazienteProps.codiceFiscale : (datiPazienteProps.stp ? datiPazienteProps.stp : "")
                datiAnagrafici.nazione = this.props.statePadre && this.props.statePadre.nazione ? this.props.statePadre.nazione : datiPazienteProps.cittadinanza ? datiPazienteProps.cittadinanza.codice ? this.state.nazioniPerCodice[datiPazienteProps.cittadinanza.codice] : "" : ""

                datiAnagrafici.dataInizio = this.props.statePadre && this.props.statePadre.dataInizio ? this.props.statePadre.dataInizio : datiAnagraficiProps.dataInizioSintomi ? Utils.transformDateForFrontend(datiAnagraficiProps.dataInizioSintomi) : ""
                datiAnagrafici.comuneInizio = this.props.statePadre && this.props.statePadre.comuneInizio ? this.props.statePadre.comuneInizio : datiAnagraficiProps.comuneInizioSintomi ? this.state.comuniPerCodice[datiAnagraficiProps.comuneInizioSintomi] : ""
                datiAnagrafici.provincia = this.props.statePadre && this.props.statePadre.provincia ? this.props.statePadre.provincia : datiAnagrafici.comuneInizio ? this.state.provincePerCodice[datiAnagrafici.comuneInizio.codiceProvincia] : ""
                datiAnagrafici.ricoverato = this.props.statePadre && this.props.statePadre.ricoverato ? this.props.statePadre.ricoverato : datiAnagraficiProps.ricovero ? datiAnagraficiProps.ricovero === "1" ? "ricoverato1" : "ricoverato2" : ""
                datiAnagrafici.dataRicovero = this.props.statePadre && this.props.statePadre.dataRicovero ? this.props.statePadre.dataRicovero : datiAnagraficiProps.dataRicovero ? Utils.transformDateForFrontend(datiAnagraficiProps.dataRicovero) : ""
                datiAnagrafici.quadroClinico.altroSpecificare = this.props.statePadre && this.props.statePadre.quadroClinico && this.props.statePadre.quadroClinico.altroSpecificare ? this.props.statePadre.quadroClinico.altroSpecificare : datiAnagraficiProps.quadroClinico && datiAnagraficiProps.quadroClinico.altroSpecificare ? datiAnagraficiProps.quadroClinico.altroSpecificare : ""
            }
        }

        this.controlloDati(datiAnagrafici)
        this.props.setDatiAnagraficiMIB(this.state.datiAnagrafici, "", this.createOggettoBE())

        this.disabledDate()

    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevState !== this.state) {
            this.props.setDatiAnagraficiMIB(this.state.datiAnagrafici, this.validate(), this.createOggettoBE())
        }
        this.disabledDate()
    }

    validate() {

        if (this.state.datiAnagrafici.dataNascita && Utils.validateDate(this.state.datiAnagrafici.dataNascita, "Messages.DataNascita", "Messages.DataNascitaOdierna")) {
            return Utils.validateDate(this.state.datiAnagrafici.dataNascita, "Messages.DataNascita", "Messages.DataNascitaOdierna")
        }
        if (this.state.datiAnagrafici.dataInizio && Utils.validateDate(this.state.datiAnagrafici.dataInizio, "Messages.DataSintomi", "Messages.DataSintomiOdierna")) {
            return Utils.validateDate(this.state.datiAnagrafici.dataInizio, "Messages.DataSintomi", "Messages.DataSintomiOdierna")
        }
        if (this.state.datiAnagrafici.dataRicovero && Utils.validateDate(this.state.datiAnagrafici.dataRicovero, "Messages.DataRicovero", "Messages.DataRicoveroOdierna")) {
            return Utils.validateDate(this.state.datiAnagrafici.dataRicovero, "Messages.DataRicovero", "Messages.DataRicoveroOdierna")
        }

        return ""

    }

    disabledDate() {
        if (this.state.datiAnagrafici.ricoverato === "ricoverato1")
            $(document).ready(function () {
                $("#dataRicovero").datepicker('enable');
            })
        else
            $(document).ready(function () {
                $("#dataRicovero").datepicker('disable');
            })

    }

    createOggettoBE() {
        let datiAnagrafici = JSON.parse(JSON.stringify(this.state.datiAnagrafici))
        let datiAnagraficiBe = Utils.removeEmptyValueFromObject(datiAnagrafici)
        if (datiAnagrafici.comune && datiAnagrafici.comune.codice) {
            datiAnagrafici.comune = datiAnagrafici.comune.codice
        }
        if (datiAnagrafici.provincia && datiAnagrafici.provincia.codice) {
            datiAnagrafici.provincia = datiAnagrafici.provincia.codice
        }
        if (datiAnagrafici.nazione && datiAnagrafici.nazione.codice) {
            datiAnagrafici.nazione = datiAnagrafici.nazione.codice
        }
        if (datiAnagrafici.comuneInizio && datiAnagrafici.comuneInizio.codice) {
            datiAnagrafici.comuneInizio = datiAnagrafici.comuneInizio.codice
        }
        return Utils.removeFieldFromObject(datiAnagraficiBe, "corretto")

    }

    controlloDati(datiAnagrafici) {

        let datiPaziente = this.props.datiPaziente
        datiAnagrafici.corretto = []
        let quadroClinicoValorizzato = false
        // let correttoAnagrafica
        // let correttoStruttura

        if (!datiAnagrafici.dataNascita || (datiAnagrafici.dataNascita && Utils.isDateInValid(Utils.transformDateForBackend(datiAnagrafici.dataNascita), "-"))) datiAnagrafici.corretto[0] = "Campo \"Data di nascita\" mancante o errato";
        if (!datiAnagrafici.sesso) datiAnagrafici.corretto[1] = "Campo \"Sesso\" mancante";
        if (!datiAnagrafici.dataInizio || (datiAnagrafici.dataInizio && Utils.isDateInValid(Utils.transformDateForBackend(datiAnagrafici.dataInizio), "-"))) datiAnagrafici.corretto[2] = "Campo \"Data di inizio\" mancante o errato";
        if (!datiPaziente.soggettoAnonimizzato && !datiAnagrafici.cognome) datiAnagrafici.corretto[3] = "Campo \"Cognome\" mancante";
        if (!datiPaziente.soggettoAnonimizzato && !datiAnagrafici.nome) datiAnagrafici.corretto[4] = "Campo \"Nome\" mancante";
        if (!datiPaziente.soggettoAnonimizzato && !datiAnagrafici.comune) datiAnagrafici.corretto[5] = "Campo \"Comune di residenza\" mancante";
        if (!datiPaziente.soggettoAnonimizzato && !datiAnagrafici.nazione) datiAnagrafici.corretto[6] = "Campo \"Nazionalità\" mancante";
        if (datiAnagrafici.ricoverato === "ricoverato1" && (!datiAnagrafici.dataRicovero || (datiAnagrafici.dataRicovero && Utils.isDateInValid(Utils.transformDateForBackend(datiAnagrafici.dataRicovero), "-")))) datiAnagrafici.corretto[7] = "Campo \"Data di ricovero\" mancante o errato";
        for (let i = 1; i < 10; i++) {
            if (datiAnagrafici.quadroClinico["checkbox" + i] === true) quadroClinicoValorizzato = true;
        }
        if (quadroClinicoValorizzato === false) datiAnagrafici.corretto[8] = "Campo \"Quadro clinico\" mancante";
        if (datiAnagrafici.quadroClinico["checkbox9"] === true && !datiAnagrafici.quadroClinico["altroSpecificare"]) datiAnagrafici.corretto[9] = "Campo \"Altro Specificare\" mancante";
        if (!datiAnagrafici.paziente) datiAnagrafici.corretto[10] = "Campo \"Al momento della segnalazione il paziente è\" mancante";

        this.setState({datiAnagrafici: datiAnagrafici})
    }

    riceviValoreRadioButton(event, field) {

        let datiAnagrafici = this.state.datiAnagrafici
        datiAnagrafici[field] = event
        if (event !== "ricoverato1" && field === "ricoverato") {
            datiAnagrafici.dataRicovero = "";
        }
        this.controlloDati(datiAnagrafici)
        this.props.setDatiAnagraficiMIB(this.state.datiAnagrafici, "", this.createOggettoBE())
    }

    riceviValore(field, event) {
        let datiAnagrafici = this.state.datiAnagrafici

        if (field === "comuneInizio") {
            datiAnagrafici[field] = event.target.value
            datiAnagrafici["provincia"] = this.state.provincePerCodice[event.target.value.codiceProvincia]
        } else {
            if (field.currentTarget) {
                datiAnagrafici[field.currentTarget.id] = field.currentTarget.value
            } else {
                if (field.includes("checkbox")) {
                    if (event.target.value === "false") {
                        datiAnagrafici.quadroClinico[field] = false
                        if (field.includes("checkbox9"))
                            datiAnagrafici.quadroClinico.altroSpecificare = ""
                    } else
                        datiAnagrafici.quadroClinico[field] = true
                }
                if (field.includes("altroSpecificare")) {
                    datiAnagrafici.quadroClinico[field] = event.target.value
                } else {
                    datiAnagrafici[field] = event.target.value
                }
            }
        }

        this.controlloDati(datiAnagrafici)
        this.props.setDatiAnagraficiMIB(this.state.datiAnagrafici, "", this.createOggettoBE())
    }


    render() {

        const {t} = this.props;
        let suggestionComuneNazione = this.state.listaComuni.concat(this.state.listaNazioni);
        const sezione1 = (
            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.titolo")}</h6>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div className="container" style={{marginTop: "1rem"}}>

                    <div className="row">

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.cognome")}
                                {this.props.datiPaziente && !this.props.datiPaziente.soggettoAnonimizzato ?
                                    <span className={stylesWelcome.mandatoryColor}>*</span> : null}
                            </p>
                            <Input id={"cognome"}
                                   onChange={this.riceviValore}
                                   field={"cognome"}
                                   value={this.state.datiAnagrafici.cognome}
                                   placeholder={t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.cognome")}/>
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.nome")}
                                {this.props.datiPaziente && !this.props.datiPaziente.soggettoAnonimizzato ?
                                    <span className={stylesWelcome.mandatoryColor}>*</span> : null}</p>
                            <Input id={"nome"}
                                   onChange={this.riceviValore}
                                   field={"nome"}
                                   value={this.state.datiAnagrafici.nome}
                                   placeholder={t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.nome")}/>
                        </div>


                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.dataNascita")}
                                <span className={stylesWelcome.mandatoryColor}>*</span></p>
                            <Calendar
                                id={"dataNascita"}
                                value={this.state.datiAnagrafici.dataNascita}
                                field={"dataNascita"}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.dataNascita"))}
                                error={(this.state.datiAnagrafici.dataNascita === "" || this.state.datiAnagrafici.dataNascita == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiAnagrafici.dataNascita), "-")
                                }
                            >
                            </Calendar>
                        </div>
                        <div className="col-lg-2">
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.sesso")}
                                <span className={stylesWelcome.mandatoryColor}>*</span></p>
                            <div className="row">
                                <RadioButton id={"sesso1"}
                                             name={"sesso"}
                                             style={{fontSize: "16px"}}
                                             label={"M"}
                                             value={"1"}
                                             onClick={() => this.riceviValoreRadioButton("sesso1", "sesso")}
                                             checked={this.state.datiAnagrafici.sesso === "sesso1"}
                                />

                                <RadioButton id={"sesso2"}
                                             name={"sesso"}
                                             style={{color: "black", fontSize: "16px"}}
                                             label={"F"}
                                             value={"2"}
                                             onClick={() => this.riceviValoreRadioButton("sesso2", "sesso")}
                                             checked={this.state.datiAnagrafici.sesso === "sesso2"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione2 = (

            <div>
                <div className="container">
                    <div className="row">

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.comune")}
                                {this.props.datiPaziente && !this.props.datiPaziente.soggettoAnonimizzato ?
                                    <span className={stylesWelcome.mandatoryColor}>*</span> : null}
                            </p>
                            <div className={stylesWelcome.fieldContainer}>
                                <Autocomplete
                                    id={"comune"}
                                    keyField={"codice"}
                                    value={this.state.datiAnagrafici.comune}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    onChange={this.riceviValore}
                                    field={"comune"}
                                    placeholder={t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.comune")}
                                    suggestions={suggestionComuneNazione}
                                />
                            </div>
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.stp")}
                            </p>
                            <Input id={"stp"}
                                   onChange={this.riceviValore}
                                   field={"stp"}
                                   value={this.state.datiAnagrafici.stp}
                                   placeholder={t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.stp")}/>
                        </div>


                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.nazionalita")}
                                {this.props.datiPaziente && !this.props.datiPaziente.soggettoAnonimizzato ?
                                    <span className={stylesWelcome.mandatoryColor}>*</span> : null}
                            </p>
                            <div className={stylesWelcome.fieldContainer}>

                                <Autocomplete
                                    id={"nazione"}
                                    keyField={"codice"}
                                    value={this.state.datiAnagrafici.nazione}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    onChange={this.riceviValore}
                                    field={"nazione"}
                                    placeholder={t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.nazionalita")}
                                    suggestions={this.state.listaNazioni}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );

        const sezione3 = (

            <div>
                <div className="container" style={{marginTop: "10px"}}>
                    <div className="row">

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.dataInizio")}
                                <span className={stylesWelcome.mandatoryColor}>*</span>
                            </p>
                            <Calendar
                                id={"dataInizio"}
                                value={this.state.datiAnagrafici.dataInizio}
                                field={"dataInizio"}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.dataInizio"))}
                                error={(this.state.datiAnagrafici.dataInizio === "" || this.state.datiAnagrafici.dataInizio == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiAnagrafici.dataInizio), "-")
                                }
                            >
                            </Calendar>
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.comuneInizio")}
                            </p>
                            <div className={stylesWelcome.fieldContainer}>

                                <Autocomplete
                                    id={"comuneInizio"}
                                    keyField={"codice"}
                                    value={this.state.datiAnagrafici.comuneInizio}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    onChange={this.riceviValore}
                                    field={"comuneInizio"}
                                    placeholder={t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.comuneInizio")}
                                    suggestions={this.state.listaComuni}
                                />
                            </div>
                        </div>


                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.provincia")}
                            </p>
                            <div className={stylesWelcome.fieldContainer}>
                                <Autocomplete
                                    id={"provincia"}
                                    keyField={"codice"}
                                    value={this.state.datiAnagrafici.provincia}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    onChange={this.riceviValore}
                                    field={"provincia"}
                                    placeholder={t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.provincia")}
                                    suggestions={this.state.listaProvince}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        let defaultDivStyle = {marginTop: "-1rem"};
        let rows = [{
            label: {
                text: "SchedaFlussoSpeciale.MIB.DatiAnagrafici.QuadroClinico.titolo",
                colonna: 1,
                tipo: "label",
                asterisco: true
            },
            checkbox1: {
                id: "checkbox1",
                field: "checkbox1",
                text: "SchedaFlussoSpeciale.MIB.DatiAnagrafici.QuadroClinico.1",
                tipo: "check",
                fontColor: "black",
                colonna: 2,
                defaultChecked: this.state.datiAnagrafici.quadroClinico.checkbox1
            }
        },
            {
                checkbox2: {
                    id: "checkbox2",
                    field: "checkbox2",
                    text: "SchedaFlussoSpeciale.MIB.DatiAnagrafici.QuadroClinico.2",
                    tipo: "check",
                    fontColor: "black",
                    colonna: 2,
                    defaultChecked: this.state.datiAnagrafici.quadroClinico.checkbox2
                }
            },
            {
                checkbox3: {
                    id: "checkbox3",
                    field: "checkbox3",
                    text: "SchedaFlussoSpeciale.MIB.DatiAnagrafici.QuadroClinico.3",
                    tipo: "check",
                    fontColor: "black",
                    colonna: 2,
                    defaultChecked: this.state.datiAnagrafici.quadroClinico.checkbox3
                }
            },
            {
                checkbox4: {
                    id: "checkbox4",
                    field: "checkbox4",
                    text: "SchedaFlussoSpeciale.MIB.DatiAnagrafici.QuadroClinico.4",
                    tipo: "check",
                    fontColor: "black",
                    colonna: 2,
                    defaultChecked: this.state.datiAnagrafici.quadroClinico.checkbox4
                }
            },
            {
                checkbox5: {
                    id: "checkbox5",
                    field: "checkbox5",
                    text: "SchedaFlussoSpeciale.MIB.DatiAnagrafici.QuadroClinico.5",
                    tipo: "check",
                    fontColor: "black",
                    colonna: 2,
                    defaultChecked: this.state.datiAnagrafici.quadroClinico.checkbox5
                }
            },
            {
                checkbox6: {
                    id: "checkbox6",
                    field: "checkbox6",
                    text: "SchedaFlussoSpeciale.MIB.DatiAnagrafici.QuadroClinico.6",
                    tipo: "check",
                    fontColor: "black",
                    colonna: 2,
                    defaultChecked: this.state.datiAnagrafici.quadroClinico.checkbox6
                }
            },
            {
                checkbox7: {
                    id: "checkbox7",
                    field: "checkbox7",
                    text: "SchedaFlussoSpeciale.MIB.DatiAnagrafici.QuadroClinico.7",
                    tipo: "check",
                    fontColor: "black",
                    colonna: 2,
                    defaultChecked: this.state.datiAnagrafici.quadroClinico.checkbox7
                }
            },
            {
                checkbox8: {
                    id: "checkbox8",
                    field: "checkbox8",
                    text: "SchedaFlussoSpeciale.MIB.DatiAnagrafici.QuadroClinico.8",
                    tipo: "check",
                    fontColor: "black",
                    colonna: 2,
                    defaultChecked: this.state.datiAnagrafici.quadroClinico.checkbox8
                }
            },
            {
                checkbox9: {
                    id: "checkbox9",
                    field: "checkbox9",
                    text: "SchedaFlussoSpeciale.MIB.DatiAnagrafici.QuadroClinico.9",
                    tipo: "check",
                    fontColor: "black",
                    colonna: 2,
                    defaultChecked: this.state.datiAnagrafici.quadroClinico.checkbox9
                }, altroSpecificare: {
                    tipo: "input",
                    id: "altroSpecificare",
                    text: "SchedaFlussoSpeciale.MIB.DatiAnagrafici.QuadroClinico.altroSpecificare",
                    field: "altroSpecificare",
                    value: "altroSpecificare",
                    colonna: 3,
                    disabled: !this.state.datiAnagrafici.quadroClinico.checkbox9,
                }
            },
        ];


        const sezione4 = (
            <div className="container" style={{marginTop: "2rem"}}>
                {Utils.createDiv("col-lg-4", "col-lg-4", "col-lg-4", this.riceviValore, this.state.datiAnagrafici.quadroClinico, t, rows, "", "", "", defaultDivStyle)}
            </div>
        );

        const sezione5 = (

            <div className="container">
                <div className="row" style={{marginTop: "2rem"}}>
                    <div className="col-lg-6">
                        <div className="row">
                            <div className="col-lg-3">
                                <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                    {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.Ricoverato.ricoverato")}
                                </p>
                            </div>
                            <div className="col-lg-4">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <RadioButton id={"ricoverato1"}
                                                     name={"ricoverato"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.Ricoverato.si")}
                                                     value={"1"}
                                                     onClick={() => this.riceviValoreRadioButton("ricoverato1", "ricoverato")}
                                                     checked={this.state.datiAnagrafici.ricoverato === "ricoverato1"}
                                        />
                                    </div>
                                    <div className="col-lg-4">
                                        <RadioButton id={"ricoverato2"}
                                                     name={"ricoverato"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.Ricoverato.no")}
                                                     value={"2"}
                                                     onClick={() => this.riceviValoreRadioButton("ricoverato2", "ricoverato")}
                                                     checked={this.state.datiAnagrafici.ricoverato === "ricoverato2"}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.Ricoverato.dataRicovero")}
                                    {this.state.datiAnagrafici.ricoverato === "ricoverato1" ?
                                        <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                                </p>
                                <div>
                                    <Calendar
                                        id={"dataRicovero"}
                                        value={this.state.datiAnagrafici.dataRicovero}
                                        field={"dataRicovero"}
                                        onChange={this.riceviValore}
                                        errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.Ricoverato.dataRicovero"))}
                                        error={(this.state.datiAnagrafici.dataRicovero === "" || this.state.datiAnagrafici.dataRicovero == null) ? false :
                                            Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiAnagrafici.dataRicovero), "-")
                                        }
                                        disabled={this.state.datiAnagrafici.ricoverato !== "ricoverato1"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione6 = (

            <div className="container">
                <div className="row" style={{marginTop: "2rem"}}>
                    <div className="col-lg-12">
                        <div className="row">
                            <div className="col-lg-4">
                                <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                    {t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.Segnalazione.titolo")}
                                    <span className={stylesWelcome.mandatoryColor}>*</span>
                                </p>
                            </div>
                            <div className="col-lg-8">
                                <div className="row">
                                    <div className="col-lg-2">
                                        <RadioButton id={"paziente1"}
                                                     name={"paziente"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.Segnalazione.guarito")}
                                                     value={"1"}
                                                     onClick={() => this.riceviValoreRadioButton("paziente1", "paziente")}
                                                     checked={this.state.datiAnagrafici.paziente === "paziente1"}
                                        />
                                    </div>
                                    <div className="col-lg-2">
                                        <RadioButton id={"paziente2"}
                                                     name={"paziente"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.Segnalazione.deceduto")}
                                                     value={"2"}
                                                     onClick={() => this.riceviValoreRadioButton("paziente2", "paziente")}
                                                     checked={this.state.datiAnagrafici.paziente === "paziente2"}
                                        />
                                    </div>
                                    <div className="col-lg-8">
                                        <RadioButton id={"paziente3"}
                                                     name={"paziente"}
                                                     style={{color: "black", fontSize: "16px"}}
                                                     label={t("SchedaFlussoSpeciale.MIB.DatiAnagrafici.Segnalazione.trattamento")}
                                                     value={"3"}
                                                     onClick={() => this.riceviValoreRadioButton("paziente3", "paziente")}
                                                     checked={this.state.datiAnagrafici.paziente === "paziente3"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <div>
                {sezione1}
                {sezione2}
                {sezione3}
                {sezione4}
                {sezione5}
                {sezione6}
            </div>

        )
    }

}

export default withTranslation('common')(DatiAnagraficiMIB)
